import React, { useEffect, useState } from 'react';
import useSWR from 'swr';
import fetcher from '../../utils/fetcher';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination'
import './style.css'
import moment from "moment";
import 'moment/locale/ko';

const LatestNewsCards = () => {
  const url = 'https://api.testworks.co.kr';
  const { data: latestNewsDatas } = useSWR('https://api.testworks.co.kr/latest-news?_sort=set_day:DESC', fetcher);
  const [swiperLoaded, setSwiperLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSwiperLoaded(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className='latest-newslist'>
      {swiperLoaded && (
        <Swiper
          modules={[Pagination, Autoplay]}
          centeredSlides={true}
          slidesPerView={1}
          spaceBetween={20}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false
          }}
          loop={true}
          loopedSlides={1}
          className='mySwipper'
        >
          {latestNewsDatas?.map((data) => {
            if (data.showhome) {
              return (
                  <SwiperSlide key={data.id}>
                    <a href={data.body}
                       style={{textDecoration: 'none'}}
                       className='news-link'>
                      <div className='news-info'>
                        <div className='news-cat'>{data.category}</div>
                        <span className='news-title'>{data.title}</span>
                        <div className='card-date'>
                          <div></div>
                          <span>{moment(data.set_day).format('YYYY.MM.DD')}</span>
                        </div>
                      </div>
                      <div className='banner-img'>
                        <img src={url + data.thumbnail.url} alt='newsImg'/>
                      </div>
                    </a>
                  </SwiperSlide>
              )} else {
              return null;
            }
            })
          }
        </Swiper>
      )}
    </section>
  )
};

export default LatestNewsCards;
